module.exports = __webpack_public_path__ + "img/16.1.708f6f59.png";